import { render, staticRenderFns } from "./CreateSupplierModels.vue?vue&type=template&id=536ac4e6&scoped=true"
import script from "./CreateSupplierModels.vue?vue&type=script&lang=js"
export * from "./CreateSupplierModels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536ac4e6",
  null
  
)

export default component.exports